/**
 * PlatformSLPlatformPageView
 *
 * Page component for PlatformSLPlatformPageView
 * Path: /sl/platform
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { PlatformSLPlatformPageView as __PlatformSLPlatformPageView } from '@/components/traits/PlatformSLPlatformPageView';
import { PlatformSLPlatformAnalyticsView as __PlatformSLPlatformAnalyticsView } from '@/components/traits/PlatformSLPlatformAnalyticsView';
import { PlatformSLDemoLaunchDeskView as __PlatformSLDemoLaunchDeskView } from '@/components/traits/PlatformSLDemoLaunchDeskView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { SharedEntityStoreContext, useSharedEntityStore, usePageHead } from '@almadar/ui/hooks';
import { ToastSlot } from '@almadar/ui/components';

interface PlatformSLPlatformPageViewProps {
  // Add any page-level props here
}

export function PlatformSLPlatformPageView(_props: PlatformSLPlatformPageViewProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","std-almadar-platform:meta.title"],"description":["i18n/t","std-almadar-platform:meta.description"],"access":"public","indexing":"index","origin":"https://almadar.io","siteName":"Almadar","alternates":[{"locale":"en","path":"/platform"},{"locale":"ar","path":"/ar/platform"},{"locale":"sl","path":"/sl/platform"}],"defaultLocale":"en", path: __location.pathname });

  const _sharedStore = useSharedEntityStore();

  return (
    <SharedEntityStoreContext.Provider value={_sharedStore}>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__PlatformSLPlatformPageView config={{ initPayload: __navState }} />
          <__PlatformSLPlatformAnalyticsView config={{ initPayload: __navState }} />
          <__PlatformSLDemoLaunchDeskView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </SharedEntityStoreContext.Provider>
  );
}

export default PlatformSLPlatformPageView;
